import { useState } from 'react';
import Text from '../../Style-guide/Text';
import TabViewWrapper from './style/tabViewWrapper';

const TabView = ({ tabs, defaultTab }) => {
  const [activeTab, setActiveTab] = useState(defaultTab ?? tabs[0]?.id);

  const active = tabs.find((tab) => tab.id === activeTab);

  return (
    <TabViewWrapper className='tab-view'>
      <div className='tab-view__tabs' role='tablist'>
        {tabs.map((tab) => (
          <button
            key={tab.id}
            type='button'
            role='tab'
            aria-selected={activeTab === tab.id}
            className={
              activeTab === tab.id
                ? 'tab-view__tab tab-view__tab--active'
                : 'tab-view__tab'
            }
            onClick={() => setActiveTab(tab.id)}
          >
            <Text size='SM'>{tab.label}</Text>
          </button>
        ))}
      </div>

      <div className='tab-view__content' role='tabpanel'>
        <div key={activeTab} className='tab-view__content-inner'>
          {active?.content}
        </div>
      </div>
    </TabViewWrapper>
  );
};

export default TabView;
